<template>
  <div>
    <div class="text-right">
      <el-button type="primary" size="mini" @click="setVisible(true)">
        Create Recipe
      </el-button>
    </div>
    <el-dialog title="Create Recipe" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
        <el-form-item label="Recipe Title" prop="title">
          <el-input v-model="form.title" />
        </el-form-item>
        <el-form-item label="User" prop="user">
          <el-select
            v-model="form.user"
            placeholder="Select a user"
            remote
            filterable
            no-data-text="No users found."
            :remote-method="onQueryChange"
          >
            <el-option v-for="user in users" :key="user.id" :label="`${ user.name } (${ user.username })`" :value="user.id" />
          </el-select>
        </el-form-item>
        <div class="row">
          <div class="col-12 col-md-6">
            <el-form-item label="Category" prop="category">
              <el-select v-model="form.category" placeholder="Select a category">
                <el-option v-for="category in categories" :key="category.slug" :label="category.name" :value="category.slug" />
              </el-select>
            </el-form-item>
          </div>
          <div class="col-12 col-md-6">
            <el-form-item label="Language" prop="language">
              <el-select v-model="form.language" placeholder="Select a language">
                <el-option label="English" value="en" />
                <el-option label="Malay" value="ms" />
              </el-select>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="Type of dish" prop="dishTypes">
          <el-select v-model="form.dishTypes" multiple placeholder="Select a dish type">
            <el-option v-for="(id, name) in dishTypes" :key="id" :label="name" :value="id" />
          </el-select>
        </el-form-item>
        <el-form-item label="Cuisines" prop="cuisines">
          <el-select v-model="form.cuisines" multiple collapse-tags placeholder="Select applicable cuisines">
            <el-option v-for="(id, name) in cuisines" :key="id" :label="name" :value="id" />
          </el-select>
        </el-form-item>
        <el-form-item label="Key ingredient">
          <el-select v-model="form.keyIngredient" placeholder="Select key ingredient used">
            <el-option v-for="(id, name) in keyIngredients" :key="id" :label="name" :value="id" />
          </el-select>
        </el-form-item>
        <el-button native-type="submit" type="primary" :loading="loading">
          Save Draft
        </el-button>
        <el-button @click="onCancel">
          Cancel
        </el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        cuisines: [],
        dishTypes: [],
        keyIngredient: null,
        category: '',
        language: 'en',
        title: '',
        user: this.$store.state.user.id,
      },
      rules: {
        'cuisines': [
          { required: true, message: 'Select at least one applicable cuisine.', trigger: 'change' },
        ],
        'dishTypes': [
          { required: true, message: 'Select the dish types.', trigger: 'change' },
        ],
        'category': [
          { required: true, message: 'Select a category.', trigger: 'blur' },
        ],
        'language': [
          { required: true, message: 'Select a language.', trigger: 'blur' },
        ],
        'title': [
          { required: true, message: 'Enter a recipe title.', trigger: 'blur' },
        ],
        'user': [
          { required: true, message: 'Select a user.', trigger: 'blur' },
        ],
      },
      users: [],
      cuisines: {
        'American': 'American',
        'American Chinese': 'American Chinese',
        'Bruneian': 'Bruneian',
        'Burmese': 'Burmese',
        'Cambodian': 'Cambodian',
        'Chinese': 'Chinese',
        'Cantonese': 'Cantonese',
        'East Timorese': 'East Timorese',
        'Filipino': 'Filipino',
        'Indian': 'Indian',
        'Indonesian': 'Indonesian',
        'Japanese': 'Japanese',
        'Korean': 'Korean',
        'Laotian': 'Laotian',
        'Macanese': 'Macanese',
        'Malay': 'Malay',
        'Malaysian': 'Malaysian',
        'Pakistani': 'Pakistani',
        'Pan-Asian': 'Pan-Asian',
        'Peranakan': 'Peranakan',
        'Singaporean': 'Singaporean',
        'Taiwanese': 'Taiwanese',
        'Thai': 'Thai',
        'Vietnamese': 'Vietnamese',
      },
      dishTypes: {
        'Appetizer': 'Appetizer',
        'Basics': 'Basics',
        'Bread': 'Bread',
        'Condiment': 'Condiment',
        'Dessert': 'Dessert',
        'Drink': 'Drink',
        'Main': 'Main',
        'Side': 'Side',
        'Snack': 'Snack',
        'Soup':'Soup',
      },
      keyIngredients: {
        'Not Applicable': null,
        'Beef': 'Beef',
        'Chicken': 'Chicken',
        'Fish': 'Fish',
        'Mutton': 'Mutton',
        'Pork': 'Pork',
        'Shellfish': 'Shellfish',
        'Vegetable': 'Vegetable',
      },
      categories: [
        { slug: 'meat', title: 'Meat' },
        { slug: 'seafood', title: 'Seafood' },
        { slug: 'vegetables', title: 'Vegetables' },
        { slug: 'rice-and-noodles', title: 'Rice and Noodles' },
        { slug: 'drinks', title: 'Drinks' },
        { slug: 'soups', title: 'Soups' },
        { slug: 'desserts', title: 'Desserts and Kuihs' },
        { slug: 'condiments', title: 'Condiments and Others' },
      ],
    }
  },

  created() {
    this.users = [{
      id: this.$store.state.user.id,
      name: this.$store.state.user.name,
      username: this.$store.state.user.username,
    }]
  },

  methods: {
    onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        try {
          var { data } = await this.$http.post(`/recipes`, {
            category: this.form.category,
            cuisines: this.form.cuisines,
            dish_types: this.form.dishTypes,
            key_ingredient: this.form.keyIngredient,
            language: this.form.language,
            title: this.form.title,
            user: this.form.user,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.$router.push({ name: 'recipes-id', params: { id: data.recipe.id } })
        this.$message.success(data.message)
      })
    },

    async onQueryChange(query) {
      if (!query) {
        this.users = []
        return false
      }

      try {
        var { data } = await this.$http.get('/users', {
          params: { name: query },
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }

      this.users = data.users
    },

    setVisible(status) {
      this.dialogVisible = status
    },

    onCancel() {
      this.setVisible(false)
      this.$refs['form'].resetFields()
    },
  },
}
</script>
